import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { DialogService } from 'primeng/dynamicdialog';

import { HelperService } from 'app/services/helper.service';
import { HTTPService } from 'app/services/http.service';

import { OverlayImageComponent } from 'app/modules/shared/components/overlay-image/overlay-image.component';
import { OverlayVideoComponent } from 'app/modules/shared/components/overlay-video/overlay-video.component';

import { environment } from 'environments/environment';

import { CookieService } from 'ngx-cookie';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private token;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  /**
   * @todo create a generic http service which is responsible for all
   * header fetching etc
   */
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private helperService: HelperService,
    private router: Router,
    private dialogService: DialogService,
    private httpService: HTTPService
  ) {}

  /**
   * ==============================
   *          Helper Methods
   *  ==============================
   */

  private getHeaders() {
    const token: string = <string>(<unknown>this.cookieService.getObject('alpat'));
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: token || null,
    });
    return headers;
  }

  private getFileHeaders(token: any = '') {
    if (!token) {
      token = this.cookieService.getObject('alpat');
    }

    this.headers = new HttpHeaders({
      authorization: token ? token : null,
    });

    return this.headers;
  }

  private successHandler(res: any) {
    const d = res;

    try {
      if (d.status) {
        return Promise.resolve(d.response);
      }
    } catch (err) {
      console.error('Success Handler catch', err);
    }
  }

  private errorHandler(result: any) {
    try {
      if (!result.error.status) {
        if (result.status === 440) {
          this.helperService.logout();
        }

        return Promise.reject(result.error.error);
      }
    } catch (err) {
      console.error('Error Handler catch', err);
    }
  }

  /**
   * Open image file preview
   */
  openImagePreview(data: { name: string; url: string; type: string }) {
    this.dialogService.open(OverlayImageComponent, {
      // styleClass: 'add-dialog overflow-auto',
      // width: '80%',
      styleClass: 'lightgallery carousel-dialog',
      width: '100%',
      showHeader: false,
      data: {
        images: [data],
        url: data.url,
        name: data.name,
      },
    });
  }

  /**
   * Open video file preview
   */
  openVideoPreview(data: { name: string; url: string }) {
    this.dialogService.open(OverlayVideoComponent, {
      styleClass: 'add-dialog overflow-auto',
      width: '80%',
      showHeader: false,
      data,
    });
  }

  /**
   * Get signed url
   */
  async getSignedUrl(payload: { path?: String; key?: String; token?: any }): Promise<string> {
    // Destruct requried details
    const { path, key, token = null } = payload;

    // Check if path or key provided for file
    if (!path && !key) {
      throw new Error('File path or key is required');
    }

    // Get data
    const data: any = await this.http
      .post(`${environment.api_base_url}/file/signedUrl`, payload, {
        headers: this.getFileHeaders(token),
      })
      .toPromise()
      .then(this.successHandler.bind(this))
      .catch(this.errorHandler.bind(this));

    // Destruct signed url
    const { signedUrl } = data;

    // // Return url
    return <string>signedUrl;
  }

  /**
   * Get signed url
   */
  async getSignedUrlForCustomer(payload: { path?: String; key?: String; token?: any }): Promise<string> {
    // Destruct requried details
    const { path, key, token = null } = payload;

    // Check if path or key provided for file
    if (!path && !key) {
      throw new Error('File path or key is required');
    }

    // Get data
    const data: any = await this.http
      .post(`${environment.api_base_url}/file/signedUrl/customer`, payload, {
        headers: this.getFileHeaders(token),
      })
      .toPromise()
      .then(this.successHandler.bind(this))
      .catch(this.errorHandler.bind(this));

    // Destruct signed url
    const { signedUrl } = data;

    // // Return url
    return <string>signedUrl;
  }

  async getSignedUrlDL(payload: { path?: String; key?: String; token?: any }): Promise<string> {
    // Destruct requried details
    const { path, key, token = null } = payload;

    // Check if path or key provided for file
    if (!path && !key) {
      throw new Error('File path or key is required');
    }

    // Get data
    const data: any = await this.http
      .post(`${environment.api_base_url}/file/dl/signedUrl`, payload, {
        headers: this.getFileHeaders(token),
      })
      .toPromise()
      .then(this.successHandler.bind(this))
      .catch(this.errorHandler.bind(this));

    // Destruct signed url
    const { signedUrl } = data;

    // // Return url
    return <string>signedUrl;
  }
}
